import gql from 'graphql-tag';

const query = gql`
  query GoalSettings {
    me {
      id
      birthDate
      height {
        value
        unit
      }
      sex
      systemOfMeasures
      systemOfMeasuresNutrition
    }
  }
`;

export default query;
